import { BookPlus } from 'lucide-react';
import { useCallback } from 'react';
import { toast } from 'sonner';

import { IStep, useAuth, useChatSession } from '@chainlit/react-client';

import Translator from '@/components/i18n/Translator';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';

interface NotepadButtonProps {
  message: IStep;
}

export function NotepadButton({ message }: NotepadButtonProps) {
  const { session } = useChatSession();
  const { user } = useAuth();

  const handleNotepadClick = useCallback(() => {
    if (session?.socket) {
      session.socket.emit('send_to_new_notepad', message);
      toast.success(<Translator path="chat.messages.notepad.success" />);
    }
  }, [message, session]);

  const isDisabled = message.streaming || !session?.socket;

  if (!user) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            disabled={isDisabled}
            onClick={handleNotepadClick}
            className="text-muted-foreground hover:text-foreground"
          >
            <BookPlus className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <Translator path="chat.messages.notepad.send" />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
